'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var classNames = _interopDefault(require('classnames/dedupe'));
var Icon = require('../../01.atoms/Icon/Icon.js');
require('./_index.scss.js');

var CLASSNAME = 'varta-highlight-bullet-list',
    cnList = "".concat(CLASSNAME, "__list"),
    cnItem = "".concat(CLASSNAME, "__item"),
    cnIcon = "".concat(CLASSNAME, "__icon");
/**
 * 
 * @param {*} param0 
 * @returns 
 */

function HighlightBulletList(_ref) {
  var className = _ref.className,
      headline = _ref.headline,
      items = _ref.items,
      style = _ref.style;
  var List = style === 'ordered' ? 'ol' : 'ul';
  var check = style === 'check';
  return /*#__PURE__*/React__default.createElement("div", {
    className: classNames(CLASSNAME, className)
  }, headline && /*#__PURE__*/React__default.createElement("h2", null, headline), /*#__PURE__*/React__default.createElement(List, {
    className: classNames(cnList, "".concat(cnList, "--").concat(style))
  }, items.map(function (item, i) {
    return /*#__PURE__*/React__default.createElement("li", {
      key: i,
      className: classNames(cnItem, "".concat(cnItem, "--").concat(style))
    }, check && /*#__PURE__*/React__default.createElement(Icon, {
      id: "check",
      size: "xs",
      className: cnIcon
    }), item);
  })));
}
HighlightBulletList.propTypes = {
  /** Additional class name */
  className: PropTypes.string,

  /** Title of list */
  headline: PropTypes.string,

  /** Array of bullet points */
  items: PropTypes.arrayOf(PropTypes.string),

  /** Style of li */
  style: PropTypes.oneOf(['check', 'ordered', 'unordered'])
};
HighlightBulletList.defaultProps = {
  style: 'check'
};

module.exports = HighlightBulletList;
